module.exports = __webpack_public_path__ + "static/media/20210109_214005_576_IMG_1795.942f63fe.jpg";